import { render, staticRenderFns } from "./lrdjChaXun.vue?vue&type=template&id=8fbdc472&scoped=true&"
import script from "./lrdjChaXun.vue?vue&type=script&lang=js&"
export * from "./lrdjChaXun.vue?vue&type=script&lang=js&"
import style0 from "./lrdjChaXun.vue?vue&type=style&index=0&id=8fbdc472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fbdc472",
  null
  
)

export default component.exports